import React from "react";
import CalBooking from "../components/CalBooking";

/**
 * Página PÚBLICA de autoagenda — a diferencia de todo el resto de la app (que es la herramienta
 * interna de recepción/doctor), esta pantalla la ve el paciente, sin login. El horario que elija
 * NO crea una cita real de una: queda como solicitud pendiente hasta que recepción la apruebe
 * (ver SolicitudCitaController).
 */
function Reservar() {
  const nombreDoc = process.env.REACT_APP_NOMBRE_DOC || "tu doctor/a";

  return (
    <div className="w-full min-h-screen bg-dry">
      <div className="w-full py-10 flex-colo">
        <img
          src="/images/logomenu.png"
          alt="logo"
          className="w-48 h-16 object-contain mb-4"
        />
        <h1 className="text-2xl font-bold text-center">Reservá tu consulta</h1>
        <p className="text-sm text-textGray text-center mt-1">
          con {nombreDoc}
        </p>
      </div>
      <div className="w-full sm:w-4/5 lg:w-3/5 mx-auto bg-white rounded-2xl shadow p-2 sm:p-6 mb-10">
        <CalBooking />
      </div>
    </div>
  );
}

export default Reservar;
